import httpClient from './http-client';

const TotalSubscriptions = (filter: any): Promise<any> => {
    const params = {
        query: filter
    };

    return httpClient.invoke('reports', 'totalSubscriptions', params);
};

const TotalSubscriptionsCSV = (filter: any): Promise<any> => {
    const params = {
        query: filter
    };

    return httpClient.invoke('reports', 'totalSubscriptionsCsv', params);
};

export default {
    TotalSubscriptions,
    TotalSubscriptionsCSV
}